import React from 'react';
import { ProductFilter } from './ProductFilter';
import { Product } from 'core/product/Product';
import { ProductListColumns, useProductListModel } from './ProductListModel';
import { StickableBootstrapTable } from 'components/Table/StickableBootstrapTable';
import i18n from 'i18n';
import styles from './productList.module.scss';
import { Pagination } from 'core/pagination/Pagination';
import { TableChangeHandler } from 'react-bootstrap-table-next';
import classnames from 'classnames/bind';
import { ProductListOverview } from './ProductListOverview';
const cx = classnames.bind(styles);

export type ProductListProps = {
  filterSet: ProductFilter;
  productList: Product[];
  allProducts?: Product[];
  pagination: Pagination;
  editActions?: {
    label: string;
    onClick: (
      selectedProducts: string[],
      cb?: () => void,
    ) => void | Promise<void>;
  }[];
  handleCloseModal?: () => void;
  onListChange?: TableChangeHandler<Product>;
  singleSelect?: boolean;
  limitSelect?: boolean;
};

export const ProductList: React.FC<ProductListProps> = ({
  filterSet,
  pagination,
  productList,
  editActions,
  singleSelect,
  limitSelect,
  allProducts = productList,
  onListChange,
}) => {
  const {
    state,
    columns,
    selectedProducts,
    availbleProducts,
    // onProductListTypeChange,
    handleRemoveSelect,
    handleRemoveProduct,
  } = useProductListModel(
    filterSet,
    productList,
    allProducts,
    singleSelect,
    limitSelect,
  );

  const renderOverviewBar = () => {
    const renderItems = () => {
      if (!editActions) {
        return;
      }

      return editActions.map((editAction) => {
        const onClick = (event) => {
          event && event.stopPropagation();
          editAction.onClick(selectedProducts, handleRemoveSelect);
        };
        return (
          <div key={editAction.label} onClick={onClick}>
            {i18n.t<string>(editAction.label)}
          </div>
        );
      });
    };
    const productToOverview = availbleProducts.filter((product) =>
      selectedProducts.includes(product.productId.toString()),
    );
    return (
      <ProductListOverview
        products={productToOverview}
        handleRemoveAll={handleRemoveSelect}
        handleRemoveProduct={handleRemoveProduct}
      >
        {renderItems()}
      </ProductListOverview>
    );
  };

  const contentAreaClass = cx(styles.contentArea, {
    hasEditBar: selectedProducts.length > 0,
  });

  return (
    <div className={styles.productListArea}>
      {selectedProducts.length > 0 && (
        <div className={styles.productListTitleBar}>{renderOverviewBar()}</div>
      )}
      <div className={contentAreaClass}>
        <StickableBootstrapTable
          key={state.selectedProductListType}
          stickFirstColumn
          scrollByElementControl={false}
          remote={onListChange ? true : false}
          keyField={ProductListColumns.ID}
          data={productList}
          columns={columns}
          noDataIndication={
            filterSet.advertiser
              ? i18n.t<string>('productList.labels.noData')
              : i18n.t<string>('productList.labels.needAdvertiser')
          }
          defaultSorted={[
            {
              dataField: ProductListColumns.ID,
              order: 'desc',
            },
          ]}
          pagination={{
            page: pagination.page,
            sizePerPage: 25,
            totalSize: pagination.totalCount,
          }}
          onTableChange={onListChange}
        />
      </div>
    </div>
  );
};
